"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginController = function LoginController(Account, growl, $http, store, $state) {
  "ngInject";

  (0, _classCallCheck3.default)(this, LoginController);
  var vm = this;
  vm.user = {
    username: "",
    password: ""
  };
  vm.login = login;

  function login() {
    Account.login(vm.user.username, vm.user.password).then(function (res) {
      growl.info("Login effettuato con successo!");
      store.set("token", "Bearer " + res.data.id_token);
      $http.defaults.headers.common.Authorization = store.get("token");
      $state.go("dashboard.list", { modelEnum: 'CULTURE' });
    }, function (err) {
      growl.error("Username o password non corretti. Riprovare");
    });
  }
};

exports.default = LoginController;


// WEBPACK FOOTER //
// ./client/app/components/login/login.controller.js